import { FC } from "react";

import styles from "./Icons.module.css";

type Props = {
  onRemove?: () => void;
};

export const Remove: FC<Props> = ({ onRemove }) => {
  return (
    <span
      className={styles.icon}
      style={{ color: "var(--color-danger)" }}
      onClick={onRemove}
    >
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </span>
  );
};
